<template>
    <div class="world-pay-3ds-ddc" v-if="bin">
        <!-- Using your preferred programming language, set the 'action' attribute with the value of the query string parameter containing the 'deviceDataCollection.url' from the device data initialization response -->
        <form id="collectionForm" name="devicedata" method="POST" :action="url" ref="collectionForm">

            <!-- Using your preferred programming language, set the 'value' attribute with the value of the query string parameter containing the 'deviceDataCollection.bin' from the device data initialization response -->
            <input type="hidden" name="Bin" :value="bin" />


            <!-- Using your preferred programming language, set the 'value' attribute with the value of the query string parameter containing the 'deviceDataCollection.jwt' from the device data initialization response -->
            <input type="hidden" name="JWT" :value="jwt" />

        </form>
    </div>
</template>
<script>
// import { mapActions } from "vuex";
export default {
    name: "WorldPay3DSDDC",
    props: {
    },
    data() {
        return {
            bin: null,
            jwt: null,
            url: null
        }
    },
    computed: {
    },
    created() {
        // window.addEventListener("message", event => {
        //     console.log(event.origin);
        //     console.log(event.data);
        //     window.parent.postMessage(event.data);
        // });
    },
    mounted() {
        let ctrl = this;
        let {jwt, bin, url} = this.$router.currentRoute.query;
        if(jwt && bin && url) {
            ctrl.bin = bin;
            ctrl.jwt = jwt;
            ctrl.url = url;
            setTimeout(() => {
                ctrl.$refs.collectionForm.submit();
            }, 500);
        }
    },
    methods: {
    }
};
</script>
<style>
header, footer {
    display: none;
}
</style>